//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.AreaMillingContainment.js";
import "../CAM/CAM.InheritableIntBuilder.js";
let d=[[[0,"AddCenterPasses",1,0],[0,"AmAddPasses",1,0],[0,"AmAutoPatCenter",1,0],[0,"AmPocketDir",1,0],[0,"CutAngleBuilder",0,"CAM.CutAngle",0],[1,"NumberOfStepoversPerSide",0,"CAM.InheritableIntBuilder",0],[0,"PatternCenterPoint",1,"Point",0],[0,"PatternDirection",1,0],[0,"PatternSmooth",1,0]],[],[]];
SPLM.CAM.AreaMillingNonSteepContainment = class extends SPLM.CAM.AreaMillingContainment{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.AreaMillingNonSteepContainment";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.AreaMillingNonSteepContainment.PatternDirectionTypes = Object.freeze({
    "Outward" : "Outward", "Inward" : "Inward"});

SPLM.CAM.AreaMillingNonSteepContainment.AmPocketDirTypes = Object.freeze({
    "Outward" : "Outward", "Inward" : "Inward"});

SPLM.CAM.AreaMillingNonSteepContainment.AutoPatCenterTypes = Object.freeze({
    "Automatic" : "Automatic", "Specify" : "Specify"});

export default SPLM;